document.addEventListener("DOMContentLoaded", function () {
    function limitReviews() {
        let reviews = document.querySelectorAll(".kl_reviews__review_item");
        let showMoreButton = document.querySelector(".kl_reviews__button");

        if (reviews.length > 3) {
            reviews.forEach((review, index) => {
                if (index >= 3) {
                    review.style.display = "none";
                }
            });

            if (showMoreButton) {
                showMoreButton.style.display = "block";
                showMoreButton.addEventListener("click", function () {
                    reviews.forEach(review => {
                        review.style.display = "block";
                    });
                    showMoreButton.style.display = "none";
                });
            }
        } else if (showMoreButton) {
            showMoreButton.style.display = "none";
        }
    }

    const observer = new MutationObserver(function (mutations, obs) {
        let reviewsContainer = document.querySelector(".kl_reviews__review_item");
        if (reviewsContainer) {
            limitReviews();
            obs.disconnect();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    limitReviews();
});
